import {ReactComponent} from '../app'
import {getActiveRewards, getAppliedRewards} from '../resources/RewardsResource'
import {List, Spin} from 'antd'
import {RewardItem} from '../components/cards/RewardItem'

export default class RewardsPage extends ReactComponent {
  state = {
    loading: true,
    activeRewards: [],
    activeRewardsTotal: 0,
    appliedRewards: [],
    appliedRewardsTotal: 0
  }

  async componentDidMount() {

    void this.getData()

  }

  async getData() {

    void this.updateState({loading: true})

    const {rewards: activeRewards, total_active} = await getActiveRewards()

    const {rewards: appliedRewards, total_applied} = await getAppliedRewards()

    // UNCOMMENT HERE TO SEE DATA
    //console.log(activeRewards)

    await this.updateState({
      loading: false,
      activeRewards,
      appliedRewards,
      activeRewardsTotal: total_active,
      appliedRewardsTotal: total_applied
    })

  }

  render() {
    return (
      <section className="container centered full-height">

        <Spin spinning={this.state.loading} size="large" fullscreen/>

          <h1 className="main-title">Vaše odměny</h1>

          {this.state.loading ?

            <RewardItem/>

            :

            <List
              dataSource={this.state.activeRewards}
              className="reward-items"
              renderItem={item => (<RewardItem reward={item} type="active"/>)}
              locale={{emptyText: 'Odměny pro vás právě připravujeme.'}}
              pagination={{
                pageSize: 5,
                total: this.state.activeRewardsTotal,
                align: 'center'
              }}
            />

          }

          <br/>
          <h1 className="h3 mb-2">Archiv Odměn</h1>

          {this.state.loading ?

            <RewardItem/>

            :

            <List
              dataSource={this.state.appliedRewards}
              className="reward-items"
              renderItem={item => (<RewardItem reward={item} type="applied"/>)}
              locale={{emptyText: 'Zatím nemáte žádné využité odměny.'}}
              pagination={{
                pageSize: 5,
                total: this.state.appliedRewardsTotal,
                align: 'center'
              }}
            />

          }

          <div className="menu-spacer"></div>
      </section>
    )
  }
}